import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Avatar, Badge, Button, Icon, Tooltip } from 'antd';
import classNames from 'classnames';
import Moment from 'react-moment';
import IconWhatsapp from 'react-icons/lib/fa/whatsapp'
import IconGoogle from 'react-icons/lib/fa/google'

import './index.scss';

import {
  makeGetChatItem,
  makeGetChatAccepting,
  makeGetChatRejecting,
  makeGetChatActiveValue,
  makeUnreadMessageCount,
  makeGetUnseenStallCount
} from '../../../../../../data/redux/chats_details/selectors';
import {
  updateChatStateValue,
  emitChatsCustomEvent,
  updateChatItem,
  deleteChatItem,
  chatItemClicked
} from '../../../../../../data/redux/chats_details/actions';
import { PLATFORM, SOCKET_EVENTS, CHAT_STATE, COLORS, HANDLING_ALERT } from '../../../../../../data/config/constants';
import { getAvatarBgClass, showMessage } from '../../../../../../data/config/utils';
import { IconDesktop, IconAndroid, IconApple } from '../../../../../../data/assets/icons';
import { IMG_MESSENGER } from '../../../../../../data/assets/img';

import Timer from './timer';

class ChatItem extends React.PureComponent {
  state = {
    handling_time_alert: ""
  }

  onClickChatItem = () => {
    const { chat_item, active, actions, admin_id } = this.props;
    if (!active)
      actions.chatItemClicked(chat_item, admin_id);
    else
      showMessage('warning', 'chat item is already joined the chatroom');
  };

  onClickAccept = event => {
    event.stopPropagation();
    const { chat_item, actions, is_chats_socket_connected, admin_id } = this.props;
    if (is_chats_socket_connected && chat_item) {
      const payload = {
        agentPsid: admin_id,
        clientPsid: chat_item.psid
      };
      actions.updateChatStateValue(chat_item.psid, "accepting_chat")
      actions.emitChatsCustomEvent(SOCKET_EVENTS.CHAT_ACCEPTED, payload, (err, res) => {
        actions.updateChatStateValue(null, "accepting_chat")
        if (!err && res && res.data && res.data.acceptedChatResult)
          actions.updateChatItem(res.data.acceptedChatResult);
        else
          showMessage('error', res && res.message ? res.message : "accept chat request event error occured.");
      });
    } else if (!is_chats_socket_connected)
      showMessage('warning', 'please wait, socket is not connected yet.');
  };

  onClickReject = event => {
    event.stopPropagation();
    const { chat_item, is_chats_socket_connected, actions, admin_id } = this.props;
    if (is_chats_socket_connected && chat_item) {
      const payload = {
        agentPsid: admin_id,
        clientPsid: chat_item.psid
      };
      actions.updateChatStateValue(chat_item.psid, "rejecting_chat");
      actions.emitChatsCustomEvent(SOCKET_EVENTS.CHAT_REJECTED, payload, (err, res) => {
        actions.updateChatStateValue(null, "rejecting_chat")
        if (!err && res && res.data && res.data.rejectedChatPsid)
          actions.deleteChatItem({ psid: res.data.rejectedChatPsid });
        else
          showMessage('error', res && res.message ? res.message : "accept chat request event error occured.");
      });
    } else if (!is_chats_socket_connected)
      showMessage('warning', 'please wait, socket is not connected yet.');
  };

  onPendingTimeout = () => {
    const { actions, admin_id, chat_item } = this.props;
    if (chat_item.agentId === admin_id) { // to avoid supervisor screen pending timer timeout
      const payload = {
        agentPsid: admin_id,
        clientPsid: chat_item.psid
      };
      actions.emitChatsCustomEvent(SOCKET_EVENTS.PENDING_CHAT_TIMEOUT, payload, (err, res) => {
        if (!err && res && res.data) {
          actions.deleteChatItem({ psid: res.data.timeoutChatPsid }, res.message)
          showMessage('warning', res.message ? res.message : 'pending chat timeout')
        }
      })
    }
  }

  onChangeHandlingTimeAlert = handling_time_alert => this.setState({ handling_time_alert });


  renderPlatformIcon = () => {
    const { chat_item } = this.props;
    switch (chat_item.platform) {
      case PLATFORM.WEBSITE: return (<IconDesktop size={14} className="ori-font-light ori-r-mrgn-5" />);
      case PLATFORM.ANDROID: return (<IconAndroid size={14} className="ori-font-light ori-r-mrgn-5" />);
      case PLATFORM.IOS: return (<IconApple size={14} className="ori-font-light ori-r-mrgn-5" />);
      case PLATFORM.WHATSAPP: return <IconWhatsapp size={14} className="ori-font-light ori-r-mrgn-5" />
      case PLATFORM.GOOGLE_ANALYTICS: return <IconGoogle size={14} className="ori-font-light ori-r-mrgn-5" />
      case PLATFORM.FACEBOOK: return (<img src={IMG_MESSENGER} alt="" className="ori-r-mrgn-5 messengerIcon" />);
      default:
        return null;
    }
  };

  render() {
    const {
      chat_item,
      active,
      unread_message_count,
      unseen_stall_count,
      accepting,
      rejecting,
      admin_id
    } = this.props;
    const { handling_time_alert } = this.state;
    const title = chat_item && chat_item.udf1 ? chat_item.udf1 : "unknown";
    const avatarBgClass = getAvatarBgClass(title);
    // log('ChatItem rendered', this.props.psid);
    return (
      <div
        className={classNames("ori-pad-15 ori-cursor-ptr oriChatItemContainer",
          {
            "ori-bg-default ori-r-border-color-primary": active,
            "ori-card-loading": !active && chat_item.notViewedByAgent === "true" && chat_item.chatState && chat_item.chatState === CHAT_STATE.AGENT_HANDLING && chat_item.agentId === admin_id,
            "ori-gradient-warning": handling_time_alert === HANDLING_ALERT.LONG,
            "ori-gradient-danger": handling_time_alert === HANDLING_ALERT.CRITICAL
          }
        )}
        onClick={this.onClickChatItem}
      >
        <div className="ori-flex-row">
          <div className="ori-r-pad-10">
            <Badge
              style={{
                backgroundColor: COLORS.green
              }}
              overflowCount={9}
              count={unread_message_count ? unread_message_count : 0}
            >
              <Avatar
                shape="square"
                className={classNames("ori-uppercase ori-align-avatar-letter", { ...avatarBgClass })}
              >
                {title.charAt(0)}
              </Avatar>
            </Badge>
          </div>
          <div className="ori-full-flex ori-overflow-hidden">
            <p className="ori-font-bold ori-font-sm">
              <span className="ori-uppercase">{title}</span>
              {
                chat_item.udf2 && <span>/{chat_item.udf2}</span>
              }
            </p>
            {
              chat_item.agentName && chat_item.agentId && (chat_item.chatState === CHAT_STATE.AGENT_HANDLING || chat_item.chatState === CHAT_STATE.PENDING) && chat_item.agentId !== admin_id &&
              <div className={classNames({ "ori-font-green": chat_item.chatState === CHAT_STATE.AGENT_HANDLING, "ori-font-warning": chat_item.chatState === CHAT_STATE.PENDING })}>
                <Icon type={chat_item.chatState === CHAT_STATE.AGENT_HANDLING ? "user" : "clock-circle"} />
                <span className="ori-l-pad-5 ori-font-xs ori-capitalize">{chat_item.agentName}</span>
              </div>
            }
            {
              chat_item.note && chat_item.note !== "" &&
              <p className="ori-font-green ori-font-xs ori-text-overflow-dotted">{chat_item.note}</p>
            }
            <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title="PSID">
              <p className="ori-font-light ori-font-xs ori-text-overflow-dotted">{chat_item.psid}</p>
            </Tooltip>
            {
              chat_item.sessionId &&
              <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title="Session Id">
                <p className="ori-font-light ori-font-xs ori-text-overflow-dotted">{chat_item.sessionId}</p>
              </Tooltip>
            }
            {
              chat_item.lastMessage &&
              <p className="ori-font-light ori-font-xs ori-text-overflow-dotted">{chat_item.lastMessage}</p>
            }
            <div className="ori-flex-row">
              {
                chat_item.platform &&
                <div className=" ori-flex platformIconContainer">
                  {this.renderPlatformIcon()}
                </div>
              }
              {
                chat_item.lastMessageTimeStamp &&
                <p className="ori-font-xs ori-font-light ori-full-flex">
                  <Moment fromNow >{chat_item.lastMessageTimeStamp}</Moment>
                </p>
              }
            </div>
          </div>
        </div>
        {
          chat_item.chatState === CHAT_STATE.PENDING && chat_item.pendingChatTimeStamp &&
          <div className="ori-t-pad-5 ori-flex-row ori-flex-jsb">
            <Timer timestamp={chat_item.pendingChatTimeStamp} tooltip_title="Pending Time" class_name="ori-border-warning ori-bg-warning ori-font-white" onPendingTimeout={this.onPendingTimeout} pending_timer />
            {
              chat_item.agentId === admin_id &&
              <div className="ori-flex-row">
                <Button type="primary" size="small" className="ori-font-xs ori-lr-mrgn-10" loading={accepting} disabled={rejecting} onClick={this.onClickAccept}>{accepting ? "Accepting" : "Accept"}</Button>
                <Button size="small" className="ori-font-xs" loading={rejecting} disabled={accepting} onClick={this.onClickReject}>{rejecting ? "Rejecting" : "Reject"}</Button>
              </div>
            }
          </div>
        }
        {
          chat_item.chatState && chat_item.chatState === CHAT_STATE.AGENT_HANDLING &&
          <div className="ori-flex-row ori-flex-jsb ori-flex-wrap">
            <div className="ori-flex-row ori-t-pad-5">
              <div className="iconWrapper">
                <Tooltip
                  overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag"
                  placement="topLeft"
                  title="Upvotes (Chatbot/Agent)"
                >
                  <Badge
                    style={{
                      fontSize: '10px',
                      height: '18px',
                      padding: '0 4px',
                      backgroundColor: COLORS.green
                    }}
                    overflowCount={999}
                    count={((chat_item.chatbotSessionUpvote === "0" && chat_item.adminSessionUpvote === "0") || !chat_item.chatbotSessionUpvote || !chat_item.adminSessionUpvote) ? 0 : `${chat_item.chatbotSessionUpvote}/${chat_item.adminSessionUpvote}`}
                  >
                    <div className="ori-box-24 ori-border-light ori-border-radius-4 ori-flex-column ori-flex-center ori-bg-white">
                      <Icon className="ori-font-sm ori-b-pad-5" type="like" />
                    </div>
                  </Badge>
                </Tooltip>
              </div>
              <div className="iconWrapper">
                <Tooltip
                  overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag"
                  placement="topLeft"
                  title="Downvotes (Chatbot/Agent)"
                >
                  <Badge
                    style={{
                      fontSize: '10px',
                      height: '18px',
                      padding: '0 4px',
                      backgroundColor: COLORS.danger
                    }}
                    overflowCount={999}
                    count={((chat_item.chatbotSessionDownvote === "0" && chat_item.adminSessionDownvote === "0") || !chat_item.chatbotSessionDownvote || !chat_item.adminSessionDownvote) ? 0 : `${chat_item.chatbotSessionDownvote}/${chat_item.adminSessionDownvote}`}
                  >
                    <div className="ori-box-24 ori-border-light ori-border-radius-4 ori-flex-column ori-flex-center ori-bg-white">
                      <Icon className="ori-font-sm ori-rotate-180" type="like" />
                    </div>
                  </Badge>
                </Tooltip>
              </div>
              <div className="iconWrapper">
                <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title="admin stall count">
                  <Badge style={{ fontSize: '10px', height: '18px', padding: '0 4px', backgroundColor: unseen_stall_count.admin_stall_count ? COLORS.green : COLORS.primary }} overflowCount={99} count={chat_item.adminStallCount}>
                    <div className="ori-box-24 ori-border-light ori-border-radius-4 ori-flex-column ori-flex-center ori-bg-white">A</div>
                  </Badge>
                </Tooltip>
              </div>
              <div className="iconWrapper">
                <Tooltip overlayClassName="ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" placement="topLeft" title="customer stall count">
                  <Badge style={{ fontSize: '10px', height: '18px', padding: '0 4px', backgroundColor: unseen_stall_count.customer_stall_count ? COLORS.green : COLORS.primary }} overflowCount={99} count={chat_item.customerStallCount}>
                    <div className="ori-box-24 ori-border-light ori-border-radius-4 ori-flex-column ori-flex-center ori-bg-white">C</div>
                  </Badge>
                </Tooltip>
              </div>
            </div>
            <div className="ori-flex-row ori-t-pad-5">
              {
                chat_item.acceptedChatTimeStamp &&
                <Timer
                  timestamp={chat_item.acceptedChatTimeStamp}
                  tooltip_title="Handling Time"
                  class_name="ori-border-green ori-bg-green ori-font-white ori-r-mrgn-10"
                  onChangeHandlingTimeAlert={this.onChangeHandlingTimeAlert}
                  handling_timer
                />
              }
              {
                chat_item.timestamp &&
                <Timer timestamp={chat_item.timestamp} need_attention_time={chat_item.needAttentionTime} tooltip_title="Bot Time" class_name="ori-border-warning ori-bg-warning ori-font-white" bot_timer />
              }
            </div>
          </div>
        }
      </div>
    );
  }
}

const makeMapStateToProps = () => {
  const getChatItem = makeGetChatItem();
  const getChatAccepting = makeGetChatAccepting();
  const getChatRejecting = makeGetChatRejecting();
  const getChatActive = makeGetChatActiveValue();
  const getUnreadMessageCount = makeUnreadMessageCount();
  const getUnseenStallCount = makeGetUnseenStallCount();
  const mapStateToProps = (state, props) => {
    return {
      admin_id: state.admin_details.admin_id,
      is_chats_socket_connected: state.chats_details.is_socket_connected,
      chat_item: getChatItem(state, props),
      accepting: getChatAccepting(state, props),
      rejecting: getChatRejecting(state, props),
      active: getChatActive(state, props),
      unread_message_count: getUnreadMessageCount(state, props),
      unseen_stall_count: getUnseenStallCount(state, props),
    };
  }
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updateChatStateValue,
        emitChatsCustomEvent,
        updateChatItem,
        deleteChatItem,
        chatItemClicked
      },
      dispatch),
  };
};

ChatItem.propTypes = {
  psid: PropTypes.string.isRequired,
  chat_item: PropTypes.object,
  admin_id: PropTypes.string.isRequired,
  active: PropTypes.bool,
  unread_message_count: PropTypes.number,
  unseen_stall_count: PropTypes.object,
  handleChatItemClicked: PropTypes.func,
  accepting: PropTypes.bool,
  rejecting: PropTypes.bool,
  is_chats_socket_connected: PropTypes.bool,
  actions: PropTypes.object,
};

ChatItem.defaultProps = {
  active: false,
  chat_item: {},
  accepting: false,
  rejecting: false,
  unread_message_count: 0,
  unseen_stall_count: {},
};

export default connect(makeMapStateToProps, mapDispatchToProps)(ChatItem);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/chats/components/chatitem/index.js